import { forwardRef } from 'react';
import { Input, type InputProps } from '@chakra-ui/react';

/** Sizes that keep ≥16px text (theme `md` recipe) — avoids iOS Safari focus-zoom. */
export type RiftboundInputSize = 'md' | 'lg';

export type RiftboundInputProps = Omit<InputProps, 'size'> & {
  size?: RiftboundInputSize;
};

/**
 * Shared text input. Size and surface fill come from the input recipe.
 * Prefer this over raw Chakra `Input` for form fields and search boxes.
 */
export const RiftboundInput = forwardRef<HTMLInputElement, RiftboundInputProps>(
  function RiftboundInput({ size = 'md', ...rest }, ref) {
    return <Input ref={ref} {...rest} size={size} />;
  },
);
